// SlideIn.js
import React, { useRef, useEffect, useState } from 'react';
import { Box } from '@mui/material';

const SlideIn = ({ children, direction = 'left', threshold = 0.1 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false); // Reset visibility when it goes out of view
        }
      },
      { threshold }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [threshold]);

  const slideDirection = {
    left: { transform: isVisible ? 'translateX(0)' : 'translateX(-100%)' },
    right: { transform: isVisible ? 'translateX(0)' : 'translateX(100%)' },
    up: { transform: isVisible ? 'translateY(0)' : 'translateY(-100%)' },
    down: { transform: isVisible ? 'translateY(0)' : 'translateY(100%)' },
  };

  return (
    <Box
      ref={ref}
      sx={{
        opacity: isVisible ? 1 : 0,
        transition: 'transform 0.5s ease-out, opacity 0.5s ease-out',
        overflow: 'hidden', // Hide overflow for smooth transition
        ...slideDirection[direction],
      }}
    >
      {children}
    </Box>
  );
};

export default SlideIn;
